import {
  Box,
  Grid,
  Select,
  Chip,
  Checkbox,
  IconButton,
  MenuItem,
  Typography,
  ToggleButton,
  FormControl,
  ListItemText,
  ListItemButton,
  InputLabel,
  ListItem,
  List,
  ToggleButtonGroup,
  CircularProgress,
  Button,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import _filter from 'lodash/filter';
import _orderBy from 'lodash/orderBy';
import _union from 'lodash/union';
import _unionBy from 'lodash/unionBy';
import _without from 'lodash/without';
import React, { useCallback, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ReactDOM from 'react-dom';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { v4 as uuidv4 } from 'uuid';

import Page from 'common/shared-ui/src/components/Page';
import DeleteIcon from 'common/shared-ui/src/icons/DeleteIcon';
import { generateRedirectUrl } from 'common/utils/getRedirectUrl';
import { getTranslatedText } from 'common/utils/getTranslatedText';

import {
  getProjectsSettings,
  createProjectsSettings,
  getProjectsWithQuery,
} from '../../../packages/common/api';
import { toggleDrawer } from '../app/redux/reducers/userSlice';

// Original class: saveSettingButton
const StyledSaveSettingButton = styled(Button)(theme => ({
  borderRadius: '16px !important',
}));
// Original class: settingsWrap
const StyledSettingsWrap = styled(Grid)(theme => ({
  backgroundColor: '#FFF',
  borderRadius: '16px',
  padding: '19px 64px 17px 19px !important',
}));
// Original class: filtersWrap
const StyledFiltersWrap = styled(Grid)(theme => ({
  margin: '0 !important',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  '& .MuiGrid-item': {
    padding: '0 !important',
  },

  '& $formControlWrap': {
    '& $formControl': {
      '& .MuiChip-deleteIcon': {
        position: 'relative',
        right: 0,
      },
    },
  },
}));
// Original class: formControlWrap
const StyledFormControlWrap = styled(Grid)(theme => ({
  padding: 'px 0px 3px 3px',
  border: '1px solid #E4E4EF',
  borderRadius: '16px',
}));
// Original class: formControl
const StyledFormControl = styled(FormControl)(theme => ({
  margin: '0 !important',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  '& .MuiSelect-icon': {
    display: 'none',
  },

  '& .MuiInputBase-formControl': {
    width: '100%',
    height: 'auto !important',
  },
}));
// Original class: chips
const StyledChips = styled(Box)(theme => ({
  display: 'flex',
  flexWrap: 'wrap',
  color: '#212346;',
  gap: '5px',

  '& .MuiChip-root': {
    margin: 2,
    backgroundColor: '#FFF',
    border: '1px solid #E4E4EF',
    borderRadius: '14px',
  },

  '& .MuiChip-deleteIcon': {
    height: '10px',
  },
}));
// Original class: chip
const StyledChip = styled(Chip)(theme => ({
  margin: 2,
  backgroundColor: '#FFF',
}));
// Original class: menuItemCheckbox
const StyledMenuItemCheckbox = styled(Checkbox)(theme => ({
  color: 'red',

  '& .MuiSvgIcon-root': {
    width: 16,
    height: 16,
    color: '#3448FF',
  },
}));
// Original class: columnTtl
const StyledColumnTtl = styled(Box)(theme => ({
  padding: '0 16px 5px 16px',
  fontSize: '12px !important',
}));
// Original class: notSelectedFieldsWrap
const StyledNotSelectedFieldsWrap = styled(Grid)(theme => ({
  border: '1px solid #E4E4EF',
  borderRadius: '16px',
  paddingTop: '8px',

  '& .MuiList-root': {
    width: '100%',
  },

  '& .MuiListItem-root': {
    padding: '0',
    width: '100%',
    '& .MuiListItemButton-root': {
      padding: '6px 16px',
    },
    '& .MuiTypography-root': {
      fontSize: '12px',
    },
  },
}));
// Original class: notSelectedFieldsSearch
const StyledNotSelectedFieldsSearch = styled(TextField)(theme => ({
  borderBottom: '1px solid #E4E4EF',
  padding: '6px 16px',
  fontSize: '12px !important',
  color: '#7174AC',
}));
// Original class: selectedFields
const StyledSelectedFields = styled(List)(theme => ({
  fontSize: '12px !important',

  '& .MuiListItemButton-root': {
    fontSize: '12px !important',
    padding: '6px 16px',
  },

  '& .MuiTypography-root': {
    fontSize: '12px !important',
  },
}));
// Original class: selectedFieldsWrap
const StyledSelectedFieldsWrap = styled(Grid)(theme => ({
  border: '1px solid #E4E4EF',
  borderRadius: '16px',
  paddingTop: '8px',

  '& .MuiListItem-root': {
    padding: '0',
  },
}));
const ProjectsSettings = ({ intl }) => {
  const redmineToken = useSelector(state => state.user.redmine_access_token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const closeDrawer = useCallback(
    () => dispatch(toggleDrawer(false)),
    [dispatch],
  );
  const searchPlaceholderText = intl.formatMessage({ id: 'enter' });
  const [settings, setSettings] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtersSelected, setFiltersSelected] = React.useState([]);
  const [fieldsSelected, setFieldsSelected] = React.useState([]);
  const [fieldsNotSelected, setFieldsNotSelected] = React.useState([]);
  const [searchFieldsNotSelected, setSearchFieldsNotSelected] = React.useState(
    [],
  );
  const [searchTextfield, setsearchTextfield] = React.useState('');
  useEffect(() => {
    closeDrawer();
  }, [closeDrawer]);
  const handleChangeFilters = (event, value) => {
    const filtersIsNotCheked = filtersSelected.filter(
      filter => filter.isChecked !== false,
    );

    if (value.props.value.isChecked) {
      if (filtersIsNotCheked.length > 1) {
        value.props.value.isChecked = false;
      }
    } else {
      value.props.value.isChecked = true;
    }
    let newValue = _unionBy(filtersSelected, value.props.value, 'field');
    setFiltersSelected(newValue);
  };
  const handleSaveSettings = async () => {
    setIsLoading(true);
    let fieldsSelectedIds = fieldsSelected.map(item => ({
      instance: 'project',
      field: item.field,
    }));
    let filtersSelectedIds = filtersSelected
      .filter(filter => filter.isChecked)
      .map(item => ({ instance: 'project', field: item.field }));
    let data = {
      settings: {
        filters: filtersSelectedIds,
        fields: fieldsSelectedIds,
      },
    };
    try {
      const response = await createProjectsSettings(data);
      setIsLoading(false);
      let hostUrl = generateRedirectUrl({
        host: window.location.origin,
        redmineToken,
      });
      navigate('/projects/', { state: { url: 'projects' } });
    } catch (error) {
      return console.log(error);
    }
  };
  const handleSearchAvailableFields = event => {
    if (event.target.value != '') {
      event.target.value.split('').map((letter, index, array) => {
        const tempSearchFieldsNotSelected = fieldsNotSelected.filter(field => {
          const filterFieldName = field.fieldName.slice(0, array.length);
          return (
            String(event.target.value).toLowerCase() ===
            String(filterFieldName).toLowerCase()
          );
        });
        if (tempSearchFieldsNotSelected.length < 1) {
          tempSearchFieldsNotSelected.push({
            fieldId: 'none',
            fieldName: intl.formatMessage({ id: 'not_found' }),
            checked: false,
          });
        }
        setsearchTextfield(event.target.value);
        setSearchFieldsNotSelected(tempSearchFieldsNotSelected);
      });
    } else {
      setsearchTextfield('');
      setSearchFieldsNotSelected([]);
    }
  };
  const handleDeleteField = (e, field) => {
    if (field.field != 'name' && field.fieldId != 'none') {
      let newFieldsSelected = _without(fieldsSelected, field);
      let newFieldsNotSelected = JSON.parse(JSON.stringify(fieldsNotSelected));
      newFieldsNotSelected.push(field);
      setFieldsNotSelected(
        newFieldsNotSelected.sort((a, b) =>
          a.fieldName > b.fieldName ? 1 : -1,
        ),
      );
      setsearchTextfield('');
      setSearchFieldsNotSelected([]);
      setFieldsSelected(newFieldsSelected);
    }
  };
  const handleSelectField = (e, field) => {
    if (field.fieldId != 'none') {
      let newFieldsNotSelected = _without(fieldsNotSelected, field);
      let newSearchFieldsNotSelected = _without(searchFieldsNotSelected, field);
      let newFieldsSelected = JSON.parse(JSON.stringify(fieldsSelected));
      newFieldsSelected.push(field);
      setFieldsSelected(newFieldsSelected);
      setSearchFieldsNotSelected(
        newSearchFieldsNotSelected.sort((a, b) =>
          a.fieldName > b.fieldName ? 1 : -1,
        ),
      );
      setFieldsNotSelected(
        newFieldsNotSelected.sort((a, b) =>
          a.fieldName > b.fieldName ? 1 : -1,
        ),
      );
    }
  };
  const handleDeleteFilter = (e, value) => {
    e.preventDefault();
    closeDrawer();
    const filtersIsNotCheked = filtersSelected.filter(
      filter => filter.isChecked !== false,
    );
    if (filtersIsNotCheked.length > 1) {
      value.isChecked = false;
      let newValue = _unionBy(filtersSelected, value, 'field');
      setFiltersSelected(newValue);
    }
  };
  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    let [removed] = [];
    let sourceItems;
    let destItems;
    if (source.droppableId !== destination.droppableId) {
      if (destination.droppableId == 'fieldsSelected') {
        destItems = [...fieldsSelected];
        if (searchFieldsNotSelected.length > 0) {
          sourceItems = [...searchFieldsNotSelected];
          let tempFieldsNotSelected = [...fieldsNotSelected];
          [removed] = sourceItems.splice(source.index, 1);
          tempFieldsNotSelected.splice(
            tempFieldsNotSelected.findIndex(
              ({ fieldId }) => fieldId == removed.fieldId,
            ),
            1,
          );
          if (sourceItems.length < 1) {
            sourceItems.push({
              fieldId: 'none',
              fieldName: intl.formatMessage({ id: 'not_found' }),
              checked: false,
            });
          }
          setFieldsNotSelected(
            tempFieldsNotSelected.sort((a, b) =>
              a.fieldName > b.fieldName ? 1 : -1,
            ),
          );
          setSearchFieldsNotSelected(
            sourceItems.sort((a, b) => (a.fieldName > b.fieldName ? 1 : -1)),
          );
        } else {
          sourceItems = [...fieldsNotSelected];
          [removed] = sourceItems.splice(source.index, 1);
          setFieldsNotSelected(
            sourceItems.sort((a, b) => (a.fieldName > b.fieldName ? 1 : -1)),
          );
        }
        destItems.splice(destination.index, 0, removed);
        setFieldsSelected(destItems);
      } else if (destination.droppableId == 'fieldsNotSelected') {
        destItems = [...fieldsNotSelected];
        sourceItems = [...fieldsSelected];
        if (sourceItems.length > 1) {
          [removed] = sourceItems.splice(source.index, 1);
          destItems.splice(destination.index, 0, removed);
          setFieldsNotSelected(
            destItems.sort((a, b) => (a.fieldName > b.fieldName ? 1 : -1)),
          );
          setFieldsSelected(sourceItems);
          setsearchTextfield('');
          setSearchFieldsNotSelected([]);
        }
      }
    } else {
      if (destination.droppableId == 'fieldsSelected') {
        destItems = [...fieldsSelected];
        [removed] = destItems.splice(source.index, 1);
        destItems.splice(destination.index, 0, removed);
        setFieldsSelected(destItems);
      } else if (destination.droppableId == 'fieldsNotSelected') {
        if (searchFieldsNotSelected.length > 0) {
          destItems = [...searchFieldsNotSelected];
          [removed] = destItems.splice(source.index, 1);
          destItems.splice(destination.index, 0, removed);
          setSearchFieldsNotSelected(
            destItems.sort((a, b) => (a.fieldName > b.fieldName ? 1 : -1)),
          );
        } else {
          destItems = [...fieldsNotSelected];
          [removed] = destItems.splice(source.index, 1);
          destItems.splice(destination.index, 0, removed);
          setFieldsNotSelected(
            destItems.sort((a, b) => (a.fieldName > b.fieldName ? 1 : -1)),
          );
        }
      }
    }
  };
  useEffect(() => {
    async function fetchProjectsSettings() {
      try {
        const response = await getProjectsSettings();
        let filters = [];
        let fields = [];
        let SelectedFields = [];
        let notSelectedFields = [];
        filters = response.filters.map(function (filter) {
          filter.fieldName = getTranslatedText(
            intl,
            'filter',
            filter.fieldId,
            filter.fieldName,
          );
          return filter;
        });
        fields = response.fields.map(function (field) {
          field.fieldName = getTranslatedText(
            intl,
            'filter',
            field.fieldId,
            field.fieldName,
          );
          return field;
        });
        notSelectedFields = fields
          .filter(field => !field.isChecked)
          .sort((a, b) => (a.fieldName > b.fieldName ? 1 : -1));
        SelectedFields = fields
          .filter(field => field.isChecked)
          .sort((a, b) => (a.position > b.position ? 1 : -1));
        setFiltersSelected(filters);
        setFieldsSelected(SelectedFields);
        setFieldsNotSelected(notSelectedFields);
        setSettings(response);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    }
    fetchProjectsSettings();
  }, [intl]);
  const pageTitle = intl.formatMessage({ id: 'page_title_projects_settings' });
  return (
    <Page title={pageTitle} width='100%'>
      <Grid
        container
        spacing={5}
        sx={{
          marginTop: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          position: 'relative',
        }}
      >
        <Typography variant='h1'>{pageTitle}</Typography>
        <StyledSaveSettingButton
          onClick={handleSaveSettings}
          variant='cutBluePrimary'
        >
          <FormattedMessage id='save_text' defaultMessage='Save' />
        </StyledSaveSettingButton>
      </Grid>
      <Grid
        container
        spacing={5}
        sx={{
          marginTop: 5,
          position: 'relative',
        }}
      >
        {!isLoading ? (
          <StyledSettingsWrap item xs={6}>
            <StyledFiltersWrap
              container
              spacing={5}
              sx={{
                position: 'relative',
              }}
            >
              <Grid size={3}>
                <div>{intl.formatMessage({ id: 'filter' })}</div>
              </Grid>
              <StyledFormControlWrap item xs={9}>
                <StyledFormControl>
                  <Select
                    id='filters'
                    multiple
                    value={filtersSelected}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                      },
                      style: {
                        maxHeight: 500,
                      },
                    }}
                    onChange={handleChangeFilters}
                    selectprops={{ IconComponent: () => null }}
                    renderValue={selected => {
                      selected = selected.filter(filter => filter.isChecked);
                      return (
                        <StyledChips>
                          {selected.map(value => (
                            <StyledChip
                              key={value.field}
                              label={value.fieldName}
                              clickable
                              disabled={value.field == 'status'}
                              deleteIcon={
                                <DeleteIcon
                                  width={10}
                                  height={10}
                                  viewBox='0 0 10 10'
                                  onMouseDown={event => event.stopPropagation()}
                                />
                              }
                              onDelete={e => handleDeleteFilter(e, value)}
                            />
                          ))}
                        </StyledChips>
                      );
                    }}
                  >
                    {filtersSelected.map(filter => (
                      <MenuItem
                        key={filter.field}
                        value={filter}
                        disabled={filter.field == 'status'}
                      >
                        <StyledMenuItemCheckbox
                          checked={filter.isChecked}
                          disabled={filter.field == 'status'}
                        />
                        <ListItemText primary={filter.fieldName} />
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              </StyledFormControlWrap>
            </StyledFiltersWrap>
            <Grid
              container
              spacing={5}
              sx={{
                marginTop: 5,
                justifyContent: 'space-between',
                display: 'flex',
                position: 'relative',
              }}
            >
              <DragDropContext onDragEnd={result => onDragEnd(result)}>
                <Grid size={6}>
                  <StyledColumnTtl>
                    {intl.formatMessage({ id: 'available_fields' })}
                  </StyledColumnTtl>
                  <StyledNotSelectedFieldsWrap item xs={12} container>
                    <StyledNotSelectedFieldsSearch
                      variant='standard'
                      placeholder={searchPlaceholderText}
                      value={searchTextfield}
                      onChange={handleSearchAvailableFields}
                      slotProps={{
                        input: {
                          component: StyledNotSelectedFieldsSearch,
                          disableUnderline: true,
                        },
                      }}
                    />
                    <Droppable droppableId='fieldsNotSelected'>
                      {(provided, snapshot) => (
                        <StyledSelectedFields
                          disablePadding={true}
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {searchFieldsNotSelected.length > 0 ? (
                            <>
                              {searchFieldsNotSelected.map((field, index) => {
                                return (
                                  <Draggable
                                    key={field.field}
                                    draggableId={field.field}
                                    index={index}
                                  >
                                    {provided => (
                                      <Box
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <ListItem
                                          key={field.field}
                                          onClick={e =>
                                            handleSelectField(e, field)
                                          }
                                        >
                                          <ListItemButton>
                                            <ListItemText
                                              primary={field.fieldName}
                                            />
                                          </ListItemButton>
                                        </ListItem>
                                      </Box>
                                    )}
                                  </Draggable>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {fieldsNotSelected.length > 0 &&
                              searchTextfield.length <= 0 ? (
                                <>
                                  {fieldsNotSelected.map((field, index) => {
                                    return (
                                      <Draggable
                                        key={field.field}
                                        draggableId={field.field}
                                        index={index}
                                      >
                                        {provided => (
                                          <Box
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                          >
                                            <ListItem
                                              key={field.field}
                                              onClick={e =>
                                                handleSelectField(e, field)
                                              }
                                            >
                                              <ListItemButton>
                                                <ListItemText
                                                  primary={field.fieldName}
                                                />
                                              </ListItemButton>
                                            </ListItem>
                                          </Box>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  <Box>
                                    <ListItem>
                                      <ListItemButton disabled>
                                        <ListItemText
                                          primary={intl.formatMessage({
                                            id: 'not_found',
                                          })}
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  </Box>
                                </>
                              )}
                            </>
                          )}
                          {provided.placeholder}
                        </StyledSelectedFields>
                      )}
                    </Droppable>
                  </StyledNotSelectedFieldsWrap>
                </Grid>
                <Grid size={6}>
                  <StyledColumnTtl>
                    {intl.formatMessage({ id: 'selected_fields' })}
                  </StyledColumnTtl>
                  <StyledSelectedFieldsWrap item xs={12}>
                    <Droppable droppableId='fieldsSelected'>
                      {(provided, snapshot) => (
                        <StyledSelectedFields
                          disablePadding={true}
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {fieldsSelected.map((field, index) => (
                            <Draggable
                              key={field.field}
                              draggableId={field.field}
                              isDragDisabled={
                                field.field == 'name' || field.fieldId == 'none'
                              }
                              index={index}
                            >
                              {provided => (
                                <ListItem
                                  disabled={
                                    field.field == 'name' ||
                                    field.fieldId == 'none'
                                  }
                                  onClick={e => handleDeleteField(e, field)}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <ListItemButton>
                                    <ListItemText primary={field.fieldName} />
                                  </ListItemButton>
                                </ListItem>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </StyledSelectedFields>
                      )}
                    </Droppable>
                  </StyledSelectedFieldsWrap>
                </Grid>
              </DragDropContext>
            </Grid>
          </StyledSettingsWrap>
        ) : (
          <Grid
            container
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100vh',
            }}
          >
            <CircularProgress color='secondary' />
          </Grid>
        )}
      </Grid>
    </Page>
  );
};
export default injectIntl(ProjectsSettings);
